import React      from 'react';
import PropTypes  from 'prop-types';
import Dailybonus from '../Dailybonus/Dailybonus';
import './../../../../src/VX/Asset//Less/VX/View/DailyBonusPage.less';
class DailyBonusPage extends React.Component {

	render() {
		return (
			<div className='dailybonus'>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12 col-sm-12 col-xs-12">
							<Dailybonus isMobile={false} show={true}/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

DailyBonusPage.propTypes = {
	pm: PropTypes.object.isRequired,
};
export default DailyBonusPage;